// extracted by mini-css-extract-plugin
export default {"card":"card__j0RbMXd_","body":"body__VVA4rx_A","bold":"bold__lorlFlVA","footerContainer":"footerContainer__rJO_JHDy","submitButton":"submitButton__MMgrP_Dl"};